interface Props {
    className?: string
    FillColor?: string
}

export default function LocationPin({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M12 4.5C10.3431 4.5 9 5.84315 9 7.5C9 9.15685 10.3431 10.5 12 10.5C13.6569 10.5 15 9.15685 15 7.5C15 5.84315 13.6569 4.5 12 4.5ZM10.5 7.5C10.5 6.67157 11.1716 6 12 6C12.8284 6 13.5 6.67157 13.5 7.5C13.5 8.32843 12.8284 9 12 9C11.1716 9 10.5 8.32843 10.5 7.5Z"
                fill={FillColor} />
            <path
                d="M6 7.32692C6 4.0853 8.71019 1.5 12 1.5C15.2898 1.5 18 4.0853 18 7.32692C18 9.56587 16.9182 12.1431 15.7819 14.2566C14.6301 16.3988 13.3521 18.1899 12.8343 18.8892C12.418 19.4512 11.582 19.4512 11.1657 18.8892C10.6479 18.1899 9.36992 16.3988 8.21814 14.2566C7.08184 12.1431 6 9.56587 6 7.32692ZM12 3C9.49082 3 7.5 4.96073 7.5 7.32692C7.5 9.16889 8.42004 11.4645 9.5393 13.5462C10.4263 15.196 11.3956 16.6349 12 17.4846C12.6044 16.6349 13.5737 15.196 14.4607 13.5462C15.58 11.4645 16.5 9.16889 16.5 7.32692C16.5 4.96073 14.5092 3 12 3Z"
                fill={FillColor} />
            <path
                d="M7.5 22.2C7.5 21.5373 8.03726 21 8.7 21H16.2C16.3657 21 16.5 21.1343 16.5 21.3C16.5 21.9627 15.9627 22.5 15.3 22.5H7.8C7.63431 22.5 7.5 22.3657 7.5 22.2Z"
                fill={FillColor} />
        </svg>
    )
}
